module.exports = __webpack_public_path__ + "assets/img/background-mask.5c9b5162.png";